import { Network } from "@/model";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WalletClient } from "viem";
import { RootState } from "../reducer";

export interface NetworkState {
  listNetwork: Network[];
  isLodoadingGetNetwork: boolean;

  countLoadWallet: number;

  chain: any;
  walletClient: WalletClient | undefined;
}

export const initialState: NetworkState = {
  listNetwork: [],
  isLodoadingGetNetwork: false,
  countLoadWallet: 0,
  chain: null,
  walletClient: undefined,
};

export const networkSlice = createSlice({
  name: "network",
  initialState,
  reducers: {
    loadingPreGetNetworks: (state) => {
      state.isLodoadingGetNetwork = true;
    },
    preGetNetworksSuccess: (
      state,
      { payload }: PayloadAction<Network[] | []>
    ) => {
      state.isLodoadingGetNetwork = false;
      state.listNetwork = payload;
    },
    preLoadingGetFail: (state) => {
      state.isLodoadingGetNetwork = false;
    },

    setCountLoadWallet: (state, { payload }: PayloadAction<number>) => {
      state.countLoadWallet = payload;
    },

    setChain: (state, { payload }) => {
      state.chain = payload;
    },

    setWalletClient: (state, { payload }) => {
      state.walletClient = payload;
    },
  },
});

export const sliceActions = networkSlice.actions;
export const networkReducer = networkSlice.reducer;
export const networkSelector = (state: RootState) => state.network;
